import axios from 'axios';
import { getBaseUrl } from './helpers';
import { refreshToken } from './auth';

// API Endpoints
const GET_DIAGNOSTICS_CATEGORIES_ENDPOINT = `/building/api/diagnostic/categories/`;
const GET_PROCESSES_ENDPOINT = `/building/api/processes/`;

export const getDiagnosticsCategories = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${identifier}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getDiagnosticsCategories(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getDiagnosticsDataPoints = (env, apiLocation) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${apiLocation}`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getDiagnosticsDataPoints(env, apiLocation);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getDiagnosticsData = (env, apiLocation, dataPoints = [], startTime, endTime) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  let API_ENDPOINT = `${BASE_URL}${apiLocation}?data_points=`;
  const filteredDataPointList = [];

  if (dataPoints.length > 0) {
    dataPoints.map((dataPoint) => {
      return filteredDataPointList.push(dataPoint);
    });

    API_ENDPOINT = `${API_ENDPOINT}${filteredDataPointList.join(',')}`;
  }

  API_ENDPOINT = `${API_ENDPOINT}&start_datetime=${startTime}&end_datetime=${endTime}`;

  const response = axios
    .get(API_ENDPOINT, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getDiagnosticsData(env, apiLocation, dataPoints, startTime, endTime);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getCSVData = (env, building, category, startTime, endTime, interval, tags) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const API_ENDPOINT = `${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${building}/${category}/data/export/`;

  const response = axios
    .post(API_ENDPOINT, {
      identifier: building,
      categroy_slug: category,
      start_datetime: startTime,
      end_datetime: endTime,
      data_interval: interval,
      tags, 
    }, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getCSVData(env, building, category, startTime, endTime, interval, tags);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const fetchProcesses = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const API_ENDPOINT = `${BASE_URL}${GET_PROCESSES_ENDPOINT}${building}/`;

  const response = axios
    .get(API_ENDPOINT, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);
        // eslint-disable-next-line no-undef
        return getDiagnosticsData(env, apiLocation, dataPoints, startTime, endTime);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const fetchNewMonitoringData = (env, apiLocation, startTime, endTime, interval, dataContext) => { // Not Used
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .post(apiLocation, {
      interval,
      end_datetime: endTime,
      start_datetime: startTime,
      data_point_context: dataContext,
    }, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return fetchNewMonitoringData(env, apiLocation, startTime, endTime, interval, dataContext);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const fetchNewMonitoringDataPoints = (env, building) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const API_ENDPOINT = `${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${building}/default/data-points/`;

  const response = axios
    .get(API_ENDPOINT, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return fetchNewMonitoringDataPoints(env, building);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const fetchNewCustomMonitoringData = (env, building, process, start, end, dataPoints) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const API_ENDPOINT = `${BASE_URL}${GET_PROCESSES_ENDPOINT}${building}/process/${process}/?start_datetime=${start}&end_datetime=${end}&data_points=${dataPoints}`;

  const response = axios
    .get(API_ENDPOINT, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return fetchNewCustomMonitoringData(env, building, process, start, end, dataPoints);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })

  return response;
}
